import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User updated a share link setting',
  name: 'share_url_updated',
  params: [
    {
      description: 'Share link id',
      name: 'share_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Type of object the share link was updated for',
      name: 'object_type',
      required: true,
      type: 'enum',
      values: ['clip', 'board', 'collection', 'canvas', 'asset'],
    },
    {
      description: 'Which share link setting was updated',
      name: 'updated_setting',
      required: true,
      type: 'enum',
      values: [
        'link_access',
        'metadata',
        'custom_fields',
        'comments',
        'hide_search_input',
        'hide_air_logo',
        'disable_view_settings',
        'disable_expanding_nested',
        'downloads',
        'version_control',
        'custom_colors',
        'page_width',
        'corner_rounding',
        'page_theme',
      ],
    },
    {
      description: 'New link access state (when updated_setting is link_access)',
      name: 'link_access',
      required: false,
      type: 'enum',
      values: ['enabled', 'disabled'],
    },
    {
      description: 'New metadata visibility (when updated_setting is metadata)',
      name: 'metadata',
      required: false,
      type: 'boolean',
    },
    {
      description: 'New custom fields permission level (when updated_setting is custom_fields)',
      name: 'custom_fields',
      required: false,
      type: 'enum',
      values: ['hide', 'read_only', 'editable'],
    },
    {
      description: 'New comments permission level (when updated_setting is comments)',
      name: 'comments',
      required: false,
      type: 'enum',
      values: ['hide', 'read_only', 'allow'],
    },
    {
      description: 'New hide search input state (when updated_setting is hide_search_input)',
      name: 'hide_search_input',
      required: false,
      type: 'boolean',
    },
    {
      description: 'New hide Air logo state (when updated_setting is hide_air_logo)',
      name: 'hide_air_logo',
      required: false,
      type: 'boolean',
    },
    {
      description: 'New disable view settings state (when updated_setting is disable_view_settings)',
      name: 'disable_view_settings',
      required: false,
      type: 'boolean',
    },
    {
      description: 'New disable expanding nested state (when updated_setting is disable_expanding_nested)',
      name: 'disable_expanding_nested',
      required: false,
      type: 'boolean',
    },
    {
      description: 'New downloads permission level (when updated_setting is downloads)',
      name: 'downloads',
      required: false,
      type: 'enum',
      values: ['none', 'single_file', 'all_assets'],
    },
    {
      description: 'New version control level (when updated_setting is version_control)',
      name: 'version_control',
      required: false,
      type: 'enum',
      values: ['latest_only', 'this_version', 'all_versions'],
    },
    {
      description: 'Which share page color control was changed (when updated_setting is custom_colors)',
      name: 'color_role',
      required: false,
      type: 'enum',
      values: ['header_background', 'buttons_and_headlines', 'page_background'],
    },
    {
      description:
        'New hex color value for the changed control, or null when reset to default (when updated_setting is custom_colors)',
      name: 'color_value',
      required: false,
      type: 'string',
    },
    {
      description: 'New share page width (when updated_setting is page_width)',
      name: 'page_width',
      required: false,
      type: 'enum',
      values: ['narrow', 'standard', 'wide'],
    },
    {
      description:
        'New thumbnail corner rounding (when updated_setting is corner_rounding). Persists as thumbnailRadius',
      name: 'corner_rounding',
      required: false,
      type: 'enum',
      values: ['standard', 'subtle', 'square'],
    },
    {
      description: 'New share page theme (when updated_setting is page_theme). Persists as colorMode',
      name: 'page_theme',
      required: false,
      type: 'enum',
      values: ['light', 'dark'],
    },
  ],
};

export default META;
